import { PromiseResponse } from '@types';

import {
  FetchGuideApiLegacyRequestParams,
  GetGuideApiLegacyResponse,
} from 'features/tissInvoicing/types';
import { iclinicApi } from '..';
import { TissVersionParams } from 'features/tissInvoicing/types/guide/tissVersion';

type FetchGuideApiLegacyApiParams = FetchGuideApiLegacyRequestParams & {
  clinic: string | null;
  physician: string | null;
};

export const fetchGetGuideApiLegacy = ({
  limit,
  clinic,
  physician,
  page,
}: FetchGuideApiLegacyApiParams): PromiseResponse<GetGuideApiLegacyResponse> =>
  iclinicApi.get('/tiss/appointmentguide/normalized/', {
    params: {
      limit,
      page: page || 1,
      clinic,
      physician,
    },
  });

export const fetchGetTissVersionsApiLegacy =
  (): PromiseResponse<TissVersionParams> => iclinicApi.get('tiss/versions');

export const deleteAppointmentguideApiLegacy = ({
  id,
}: {
  id: string;
}): PromiseResponse<{}> => iclinicApi.delete(`/tiss/appointmentguide/${id}/`);
